export const XS_SCREEN_BREAKPOINT: number = 600;
export const MD_SCREEN_BREAKPOINT: number = 960;
export const XL_SCREEN_BREAKPOINT: number = 1280;

export enum ScreenSize {
  XS = 1,
  MD,
  XL,
}
